var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxOutlineBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 0C16.5156 0 16.9844 0.203125 17.3906 0.609375C17.7969 1.01563 18 1.48438 18 2.01562V15.9844C18 16.5156 17.7969 16.9844 17.3906 17.3906C16.9844 17.7969 16.5156 18 15.9844 18H2.01562C1.48438 18 1.01562 17.7969 0.609375 17.3906C0.203125 16.9844 0 16.5156 0 15.9844V2.01562C0 1.48438 0.203125 1.01563 0.609375 0.609375C1.01562 0.203125 1.48438 0 2.01562 0H15.9844ZM15.9844 2.01562H2.01562V15.9844H15.9844V2.01562Z",
    fill: "#445E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOutlineBlank);
export default __webpack_public_path__ + "static/media/checkBoxOutlineBlank.11cbe9e5cfc580cbe54fba80b9f4271d.svg";
export { ForwardRef as ReactComponent };